import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod/v4';

export const env = createEnv({
  client: {
    NEXT_PUBLIC_BASE_CHAT_URL: z.url(),
    NEXT_PUBLIC_BASE_DYNAMIC_BACKEND_URL: z.url().optional(),
    NEXT_PUBLIC_BASE_BACKEND_URL: z.url(),
    NEXT_PUBLIC_BASE_LOGIN_URL: z.url(),
    NEXT_PUBLIC_BASE_PIGELLO_SOCKET_URL: z.url(),
    NEXT_PUBLIC_BASE_FILEUTILS_URL: z.url(),
    NEXT_PUBLIC_BASE_ADMIN_URL: z.url(),
    NEXT_PUBLIC_BASE_INTEGRATION_SERVICE_URL: z.url(),
    NEXT_PUBLIC_INTEGRATION_MONITOR_URL: z.url(),
    NEXT_PUBLIC_BASE_DASHBOARD_URL: z.url(),
    NEXT_PUBLIC_COMMIT_HASH: z.string().optional(),
    NEXT_PUBLIC_BASE_TF_URL: z.url(),
    NEXT_PUBLIC_CLIENT_TYPE: z.literal(['local', 'dev', 'prod']),
    NEXT_PUBLIC_CONTENTFUL_SPACE_ID: z.string().optional(),
    NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN: z.string().optional(),
  },
  runtimeEnv: {
    NEXT_PUBLIC_BASE_CHAT_URL: process.env.NEXT_PUBLIC_BASE_CHAT_URL,
    NEXT_PUBLIC_BASE_DYNAMIC_BACKEND_URL:
      process.env.NEXT_PUBLIC_BASE_DYNAMIC_BACKEND_URL,
    NEXT_PUBLIC_BASE_BACKEND_URL: process.env.NEXT_PUBLIC_BASE_BACKEND_URL,
    NEXT_PUBLIC_BASE_LOGIN_URL: process.env.NEXT_PUBLIC_BASE_LOGIN_URL,
    NEXT_PUBLIC_BASE_PIGELLO_SOCKET_URL:
      process.env.NEXT_PUBLIC_BASE_PIGELLO_SOCKET_URL,
    NEXT_PUBLIC_BASE_FILEUTILS_URL: process.env.NEXT_PUBLIC_BASE_FILEUTILS_URL,
    NEXT_PUBLIC_BASE_ADMIN_URL: process.env.NEXT_PUBLIC_BASE_ADMIN_URL,
    NEXT_PUBLIC_BASE_INTEGRATION_SERVICE_URL:
      process.env.NEXT_PUBLIC_BASE_INTEGRATION_SERVICE_URL,
    NEXT_PUBLIC_INTEGRATION_MONITOR_URL:
      process.env.NEXT_PUBLIC_INTEGRATION_MONITOR_URL,
    NEXT_PUBLIC_BASE_DASHBOARD_URL: process.env.NEXT_PUBLIC_BASE_DASHBOARD_URL,
    NEXT_PUBLIC_COMMIT_HASH: process.env.NEXT_PUBLIC_COMMIT_HASH,
    NEXT_PUBLIC_BASE_TF_URL: process.env.NEXT_PUBLIC_BASE_TF_URL,
    NEXT_PUBLIC_CLIENT_TYPE: process.env.NEXT_PUBLIC_CLIENT_TYPE,
    NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN:
      process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN,
    NEXT_PUBLIC_CONTENTFUL_SPACE_ID:
      process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID,
  },
  isServer: typeof window === 'undefined',
  skipValidation:
    process.env.NODE_ENV === 'test' || process.env.GITHUB_ACTIONS === 'true',
});
